export interface GallerySlide {
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Underwater body-position diagrams',
  'Buoyancy visuals',
  'Trim comparisons',
  'Depth-control diagrams',
  'Breathing and buoyancy concepts',
  'Equipment illustrations',
  'Mask and regulator sequences',
  'Finning and propulsion visuals',
  'Buddy positioning',
  'Hand signals',
  'Controlled ascent and descent concepts',
  'Navigation visuals',
  'Correct-vs-incorrect comparisons',
  'Common student errors',
  'Quick corrections',
  'Instructor cue cards',
  'Progression maps',
  'Drills',
  'Assessments',
  'Checklists',
  'Quick-reference tools',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5c6wBky59GkFFZurKBTR3s/Captura_de_pantalla_2026-10-08_200550.png',
    alt: "Don't use breath-holding to freeze your position: breathing error comparison with instructor cue",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sZVULVDLY654xwEdUV7byZ/Captura_de_pantalla_2026-10-08_200508.png',
    alt: 'Control the diver, protect the environment: bottom contact versus controlled position',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/o8JKmYAVG8hxJ3RvFLdKZw/Captura_de_pantalla_2026-10-08_200441.png',
    alt: 'Big inputs create big problems: BCD control oscillation versus stability in four steps',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2mqBdGEUArRKDgiBPZSgQh/Captura_de_pantalla_2026-10-08_200353.png',
    alt: 'Control depth and trim at the same time: hover side view with five checkpoints',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kHNBg98wg1MioSdoFARdvs/Captura_de_pantalla_2026-10-08_200328.png',
    alt: 'Trim equals how your body sits in the water: head high, head low and balanced horizontal trim',
  },
]
